module.exports = __webpack_public_path__ + "img/80f8c77.png";